import { Button, Card, Stack, Text } from '@mantine/core'
import type { VisitWithRelations } from '@markku/types'
import { IconChevronRight, IconClipboardCheck } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'

interface PropertySurveyCardProps {
  visit: VisitWithRelations
}

export function PropertySurveyCard({ visit }: PropertySurveyCardProps) {
  if (!visit.propertyId) {
    return null
  }

  return (
    <Card withBorder>
      <Stack gap="md">
        <Stack gap="xs">
          <Text size="lg" fw={600}>
            <IconClipboardCheck
              size={20}
              style={{ verticalAlign: 'middle', marginRight: 8 }}
            />
            Kiinteistötiedot päivitetty
          </Text>
          <Text size="sm" c="dimmed">
            Käynnillä kartoitettiin ja päivitettiin kiinteistösi tiedot.
          </Text>
        </Stack>

        <Button
          variant="light"
          fullWidth
          to={`/property/${visit.propertyId}`}
          component={Link}
          rightSection={<IconChevronRight size={16} />}
        >
          Katso kiinteistön tiedot
        </Button>
      </Stack>
    </Card>
  )
}
